import * as React from 'react';

import {
  IMAGE_DEFINITIONS,
  IMAGE_CAPTION_DEFINITIONS,
} from '@xing-com/content-editor-plugin-helpers';

import { StyledImage, StyledCaption } from './Image';

type rendererProps = {
  node: {
    type: string;
    data: {
      url: string;
      alt?: string;
    };
  };
  nodeAttributes?: any;
  renderers?: any;
  className?: string;
};

const renderer = ({
  node: { type, data },
  className,
  ...attributes
}: rendererProps): React.ReactNode => {
  if (type === IMAGE_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;
    const { url, alt } = data;
    return (
      <React.Fragment>
        <StyledImage
          {...restOfAttributes}
          alt={alt}
          className={className}
          src={url}
        />
        {children}
      </React.Fragment>
    );
  }
  if (type === IMAGE_CAPTION_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;
    return <StyledCaption {...restOfAttributes}>{children}</StyledCaption>;
  }
  return undefined;
};

export { renderer };
